import * as types from './types'

export default {
  [types.CHECKOUT]: state => {
    return state.checkoutData
  }
}
